import {snakeCase} from 'lodash';

export default (str) => snakeCase(str).toUpperCase();
